var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "header-wrapper header-icon-social-grouped",
      staticStyle: { position: "relative" }
    },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col group-toggle-wrapper" }, [
          _c(
            "button",
            {
              directives: [
                {
                  name: "b-toggle",
                  rawName: "v-b-toggle",
                  value: "collapsed",
                  expression: "'collapsed'"
                }
              ],
              class: "group-toggle",
              on: { click: _vm.toggleExpanded }
            },
            [
              _c("i", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isExpanded,
                    expression: "!isExpanded"
                  }
                ],
                staticClass: "fas fa-chevron-down collapse-indicator"
              }),
              _vm._v(" "),
              _c("i", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isExpanded,
                    expression: "isExpanded"
                  }
                ],
                staticClass: "fas fa-chevron-right collapse-indicator"
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col" }, [
          _c(
            "span",
            {
              staticClass: "group-type-title cursor-pointer",
              on: { click: _vm.toggleExpanded }
            },
            [_vm._v(_vm._s(_vm.groupTypeTitle))]
          ),
          _c("br"),
          _vm._v(" "),
          _c(
            "h2",
            {
              staticClass: "social-group-title cursor-pointer",
              on: { click: _vm.toggleExpanded }
            },
            [
              _vm._v(_vm._s(_vm.deliverableTitle) + " "),
              _c("span", { staticClass: "text-muted" }, [
                _vm._v(" " + _vm._s(_vm.totalDeliverableCount) + " Post"),
                _vm.totalDeliverableCount !== 1
                  ? _c("span", { staticClass: "below-title-post-count" }, [
                      _vm._v("s")
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.groupTypeTitle == "Campaign" ||
              _vm.groupTypeTitle == "Series" ||
              _vm.groupTypeTitle == "Campaign Series"
                ? _c(
                    "a",
                    {
                      staticClass: "group-edit-button exclude-outside-click",
                      on: { click: _vm.onEditButtonClick }
                    },
                    [_c("i", { staticClass: "fas fa-pencil-alt" })]
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          1 == 2 &&
          (_vm.getSystemSetting("social_media___show_new_post_button") ||
            _vm.namespace != "")
            ? _c(
                "button",
                {
                  staticClass:
                    "btn btn-theme header-filter-btns social-group-new-post-btn",
                  attrs: { type: "button" },
                  on: { click: _vm.newPost }
                },
                [
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.newPostButtonText(_vm.groupTypeTitle)
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "fas text-primary float-right fa-plus fa-fw"
                  })
                ]
              )
            : _vm._e()
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }